import { ParkingAngle } from "@/types/gql/graphql";
import { z } from "zod";

export const regimeParticulierValues = [
  "PAYANT",
  "PMR",
  "GRATUIT",
  "AUTOCAR",
  "TROTTINETTE",
  "LIVRAISON PERMANENTE",
  "LIVRAISON PÉRIODIQUE",
  "VÉLIB",
  "ÉLECTRIQUE",
  "TRANSPORT DE FOND",
  "MOTOS",
  "TAXI",
  "VÉLO",
  "POLICE",
  "DÉPOSE MINUTE",
  "DEUX ROUES",
  "AUTRES",
];

export enum ETypePlace {
  PAID = "Paid",
  NOT_PAID = "Not paid",
}
export const listTypeOfPlace = [ETypePlace.PAID, ETypePlace.NOT_PAID];
export const defaultTimeOfDay = { from: "00:00", to: "00:00" };

export const parkingAngleOptions = [
  { value: ParkingAngle.Parallel, label: "Parallèle" },
  { value: ParkingAngle.Perpendicular, label: "Perpendiculaire" },
  { value: ParkingAngle.Angled, label: "En épi" },
];

export const curbZoneMultipleSchema = z.object({
  parkingAngle: z.enum(ParkingAngle).optional(),
  streetName: z.string().trim().optional(),
  width: z.number().optional(),
  curbPolicyIds: z.array(z.string()).optional(),
  selectedDecrees: z.array(z.object({ value: z.string(), label: z.string() })).optional(),
});

export type CurbZoneMultipleFormValues = z.infer<typeof curbZoneMultipleSchema>;

export const defaultCurbZoneMultipleForm: CurbZoneMultipleFormValues = {
  width: 2,
  parkingAngle: ParkingAngle.Parallel,
  curbPolicyIds: [],
  streetName: "",
  selectedDecrees: [],
};

export const curbZoneFormSchema = z.object({
  parkingAngle: z.enum(ParkingAngle).optional(),
  streetName: z.string({ message: "This is required" }).trim().min(1, { message: "Nom voie cannot be empty" }),
  streetNumberStart: z.string().optional(),
  streetNumberEnd: z.string().optional(),
  length: z.number().optional(),
  width: z.number().optional(),
  calculatedArea: z.number().optional(),
  calculatedSpaces: z.number({ message: "This is required" }).min(1),
  externalId: z.string().optional(),
  note: z.string().optional(),
  curbPolicyIds: z.array(z.string()),
  selectedDecrees: z.array(z.object({ value: z.string(), label: z.string() })).optional(),
});
